<template>
  <div class="card-chat-contact">
    <div class="card-chat-contact_content">
      <span class="title">Contacto</span>
      <hr />
      <span class="space_bottom">{{ firstContact.formattedName }}</span>
      <ul>
        <li v-for="phone in firstContact.phones" :key="phone">
          <span>{{ phone }}</span>
        </li>
      </ul>
      <a v-if="contacts.length > 1" class="a_corner" @click="switchModal"
        >Ver todos</a
      >
    </div>
    <a-modal
      :visible="visibleModal"
      title="Contactos compartidos"
      @ok="switchModal"
      centered
      @cancel="() => {}"
    >
      <ul>
        <li
          v-for="contact in contacts"
          :key="contact.formattedName.replace(' ', '')"
        >
          <span>{{ contact.formattedName }}</span>
          <ul>
            <li v-for="phone in contact.phones" :key="phone">
              <span>{{ phone }}</span>
            </li>
          </ul>
          <hr />
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'CardChatContact',
  props: {
    contacts: {
      type: Array,
      name: { type: String },
      phones: { type: Array },
    },
  },
  data: () => ({
    visibleModal: false,
  }),
  computed: {
    firstContact() {
      return this.contacts[0]
    },
  },
  methods: {
    switchModal() {
      this.visibleModal = !this.visibleModal
    },
  },
}
</script>

<style lang="sass" scoped>
.card-chat-contact
  &_content
    text-align: left
    width: 230px
    position: relative
    .title
      font-weight: bold
    .space_bottom
      margin: 0 0 8px 0
      display: block
    .a_corner
      position: absolute
      right: 0
      // bottom: 0
ul, li
  padding: 0
  margin: 0
  list-style: none
</style>
